// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:e50025aa-5f29-4a3f-bc80-52c7a523a49a",
    "aws_cognito_region": "us-east-1",
    "aws_mobile_analytics_app_id": "f708c0f1d831485d84e1a7a2750270ab",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
